import { useEffect, useState } from "react";
import "@/App.css";
import "@/light.css";
import "@/immersive.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { QuoteForm } from "@/components/QuoteForm";
import Home from "@/pages/Home";
import Production from "@/pages/Production";
import RnD from "@/pages/RnD";
import Store from "@/pages/Store";
import Events from "@/pages/Events";
import EventsAdmin from "@/pages/EventsAdmin";
import { whatsappUrl } from "@/data/brand";
import { ScrollExperience } from "@/components/immersive/ScrollExperience";
import { track } from "@/services/metrics";

const ScrollTop = () => { const { pathname } = useLocation(); useEffect(() => window.scrollTo(0, 0), [pathname]); return null; };

const Shell = () => {
  const [quote, setQuote] = useState({ open: false, service: "General" });
  const { pathname } = useLocation();
  const isAdminRoute = pathname === "/events/manage";
  useEffect(() => { if (pathname !== "/events/manage") track("page_view", pathname); }, [pathname]);
  const openQuote = (service = "General") => { track("quote_open"); setQuote({ open: true, service }); };
  return <div className="App">
    <ScrollTop />
    <ScrollExperience />
    {!isAdminRoute && <SiteHeader onQuote={openQuote}/>} 
    <Routes>
      <Route path="/" element={<Home onQuote={openQuote}/>}/>
      <Route path="/production" element={<Production onQuote={openQuote}/>}/>
      <Route path="/rnd" element={<RnD onQuote={openQuote}/>}/>
      <Route path="/store" element={<Store onQuote={openQuote}/>}/>
      <Route path="/events" element={<Events onQuote={openQuote}/>}/>
      <Route path="/events/manage" element={<EventsAdmin/>}/>
    </Routes>
    {!isAdminRoute && <SiteFooter onQuote={openQuote}/>} 
    {!isAdminRoute && <a href={whatsappUrl("Hi MADMINUTE, I'd like to know more about your services.")} className="floating-whatsapp" target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" onClick={() => track("whatsapp_click")} data-testid="floating-whatsapp-button"><MessageCircle/></a>}
    {!isAdminRoute && <QuoteForm key={quote.service + quote.open} open={quote.open} defaultService={quote.service} onClose={() => setQuote({ ...quote, open: false })}/>}
    <Toaster theme="light"/>
  </div>;
};

function App() {
  return (
    <BrowserRouter><Shell /></BrowserRouter>
  );
}

export default App;
